<svelte:head>

    <title>Bestellungen - Ämtler-Bon</title>

</svelte:head>

<script context="module">

    let orderKey;

    export let preload = async ({ params }) => {

        const { orderid } = params;

        orderKey = orderid;

    };

</script>

<script>

    import Overview from "../components/overview.svelte";

</script>


<section>

    <Overview orderKey={orderKey} />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        height: inherit;
        width: 100%;
    }

    /*@media (max-width: 1024px) {*/
    /*    section {*/
    /*        height: unset;*/
    /*    }*/
    /*}*/

</style>
